import {
  faBookMedical,
  faHospital,
  faKitMedical,
  faTooth,
  faUserDoctor,
} from '@fortawesome/free-solid-svg-icons';

export const medicalProviderDirectoryLinks = [
  {
    path: 'especialidades-medicas',
    title: 'Especialidades médicas',
    breadcrumb: 'ESPECIALIDADES MÉDICAS',
    icon: faBookMedical,
    //tooltip: 'Especialidades Médicas',
  },
  {
    path: 'instituciones-profesionales',
    title: 'Instituciones y profesionales',
    breadcrumb: 'INSTITUCIONES Y PROFESIONALES',
    icon: faUserDoctor,
    //tooltip: 'Instituciones Profesionales',
  },
  {
    path: 'especialidades-guardias',
    title: 'Guardias',
    breadcrumb: 'GUARDIAS',
    icon: faHospital,
    //tooltip: 'Guardias',
  },
];

export const links = [
  {
    path: 'cartilla',
    title: 'Cartilla Médica',
    breadcrumb: 'CARTILLA MÉDICA',
    children: medicalProviderDirectoryLinks,
    tooltip:
      'Acceso a visualizar los médicos e instituciones incluidos en la cobertura médica del paciente. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
  {
    path: 'vacunas',
    title: 'Vacunas',
    breadcrumb: 'VACUNAS',
    tooltip:
      'Acceso a visualizar las vacunas efectivamente aplicadas al paciente. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
  {
    title: 'Resultados Estudios',
    path: 'estudios',
    breadcrumb: 'RESULTADOS DE ESTUDIOS',
    tooltip:
      'Acceso a visualizar los informes de estudios de laboratorio, los informes de estudios de imágenes y las propias imágenes de los estudios realizados. Figuran exclusivamente los resultados de estudios realizados en clínicas y centros propios de Swissmedical. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
  {
    title: 'Recetas',
    path: 'recetas',
    breadcrumb: 'RECETAS',
    tooltip:
      'Acceso a visualizar las recetas prescriptas al paciente desde prescriptor agil y desde Xhis Vertical de Salud. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
  {
    title: 'Autorizaciones',
    path: 'autorizaciones',
    breadcrumb: 'AUTORIZACIONES',
    tooltip:
      'Acceso a visualizar el estado de las autorizaciones emitidas por Swissmedical al paciente. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
  {
    title: 'Historial de atenciones',
    path: 'historial',
    breadcrumb: 'HISTORIAL',
    tooltip:
      'Acceso a visualizar las atenciones del paciente en centros y clínicas propias de Swiss Medical, como también de atenciones fuera de centros y clínicas propias de Swiss Medical. Cualquier inconveniente con este acceso comunicarse con Mariano Porretti vía Teams o por mail a mariano.porretti@swissmedical.com.ar',
  },
];

export const broadcrumbItems = [
  {
    path: 'tramitesonline/atencion-medica',
    breadcrumb: 'ATENCIÓN MÉDICA',
    children: links,
  },
];

export const authorizationTypes = {
  ODONTOLOGIC: 'Odontológica',
  MEDIC: 'Médica',
  MEDICATION: 'Medicación',
};

export const authorizationStatuses = {
  PENDING: 'Pendiente',
  OBSERVED: 'Observado',
  FINALIZED: 'Finalizado',
};

export const authorizationIcons = {
  [authorizationTypes.ODONTOLOGIC]: faTooth,
  [authorizationTypes.MEDIC]: faBookMedical,
  [authorizationTypes.MEDICATION]: faKitMedical,
};

export const authorizationStatusBackground = {
  [authorizationStatuses.PENDING]: 'bg-info',
  [authorizationStatuses.OBSERVED]: 'bg-secondary',
  [authorizationStatuses.FINALIZED]: 'bg-success',
};

export const medicalProviderDirectorySpecialtiesSections = {
  SPECIALTIES: 'specialties',
  URGENT_CARE: 'urgentCare',
};

export const medicalProviderDirectorySpecialtiesTypes = {
  [medicalProviderDirectorySpecialtiesSections.SPECIALTIES]: 1,
  [medicalProviderDirectorySpecialtiesSections.URGENT_CARE]: 2,
};

export const medicalProviderDirectoryInstitutionBussinessType = 4;

export const medicalProviderDirectorySpecialtiesLabels = {
  [medicalProviderDirectorySpecialtiesSections.SPECIALTIES]: 'Especialidades Médicas',
  [medicalProviderDirectorySpecialtiesSections.URGENT_CARE]: 'Guardias',
};
